<app-header />

<div class="site-wrapper">
  <main class="main">
    <router-outlet />
  </main>

  <app-cookie-consent />

  <app-footer />
</div>
@if (isLoading()) {
  <div class="spinnerLoading">
    <mat-spinner [diameter]="70"></mat-spinner>

    @if (errorSend()) {
      <p>No pudimos enviar tu información, recarga e intenta de nuevo</p>
    }
  </div>
}
